import React from 'react';

const SectionHeader = ({ label, title, invert = false }) => {
    return (
        <div className="mb-8 flex flex-wrap items-center gap-3">
            {label ? (
                <span className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] ${invert ? 'bg-white/20 text-white' : 'bg-[#fff1cc] text-[#8a6a33]'}`}>
                    {label}
                </span>
            ) : null}
            <h2 className={`text-3xl md:text-4xl font-bold ${invert ? 'text-white' : 'text-slate-900'}`}>{title}</h2>
        </div>
    );
};

export default SectionHeader;
